import { render, staticRenderFns } from "./xhsPrintComponentTip.vue?vue&type=template&id=43798c10&scoped=true"
import script from "./xhsPrintComponentTip.vue?vue&type=script&lang=js"
export * from "./xhsPrintComponentTip.vue?vue&type=script&lang=js"
import style0 from "./xhsPrintComponentTip.vue?vue&type=style&index=0&id=43798c10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43798c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43798c10')) {
      api.createRecord('43798c10', component.options)
    } else {
      api.reload('43798c10', component.options)
    }
    module.hot.accept("./xhsPrintComponentTip.vue?vue&type=template&id=43798c10&scoped=true", function () {
      api.rerender('43798c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/components/xhsPrintComponentTip.vue"
export default component.exports